import { render, staticRenderFns } from "./CampaignEditor.vue?vue&type=template&id=130534b6&scoped=true"
import script from "./CampaignEditor.vue?vue&type=script&lang=js"
export * from "./CampaignEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130534b6",
  null
  
)

export default component.exports